import {IFlash} from "~/interfaces/flashInterfaces";
import flashStoreFactory from "~/state/modules/flashStoreFactory";
import store from "~/state/store";
import {Hash} from "~/interfaces/hashInterfaces";
import {TErrorCollection} from "~/interfaces/errorInterfaces";
import assertNever from "../../global/assetNever";
import errorStoreFactory from "~/state/modules/errorStoreFactory";

interface IModuleOptions extends Hash {
  name?: string
}

type TModuleType = 'flash' | 'error'

export default class GeneralStoreFactory {
// add more overloads for different store types
  static registerModule(type: 'error', options?: IModuleOptions & { errors?: TErrorCollection })
  static registerModule(type: 'flash', options?: IModuleOptions & { flash?: IFlash })
  static registerModule(type: TModuleType, options: IModuleOptions = {name: `${type}Store`}) {
    const name = options.name || `${type}Store`
    let storeModule
    switch (type) {
      case 'flash':
        storeModule = flashStoreFactory(options.flash || {})
        break;
      case 'error':
        storeModule = errorStoreFactory(options.errors || {})
        break;
      default:
        assertNever(type)
    }
    store.registerModule(name, storeModule)
  }
}
